import axios from "../utils/axiosConfig";

const authService = {
  login: async (username, password) => {
    try {
      const response = await axios.post("/auth/login", { username, password });
      if (response.data.token) {
        localStorage.setItem("access_token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  logout: () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
  },

  getCurrentUser: () => {
    return JSON.parse(localStorage.getItem("user"));
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem("access_token");
  }
};

export default authService;
